import { useAtomValue } from 'jotai';
import { pathnameUrlLanguageAtom } from '../../../../history';

export const LanguageSelectorLabelText = () => {
  const language = useAtomValue(pathnameUrlLanguageAtom);
  return language;
};
